import { prependBackendAPIHost } from "repoV2/utils/common/api/api";

export const META_PIXEL_API_URLS = {
    POST_CONVERSION_API_EVENT: prependBackendAPIHost(
        "analytics/fb/conversion/post"
    ),
};
